import React from 'react'
import PageHeader from '../components/shared/pageHeader/PageHeader'
import LeadsHeader from '../components/leads/LanguageHeader'
import LanguageTable from '../components/leads/LanguageCreate'
import Footer from '../components/shared/Footer'

const LanguagesCreateTable = () => {
    return (
        <>
            <PageHeader>
               
            </PageHeader>
            <div className='main-content'>
                <div className='row'>
                    <LanguageTable />
                </div>
            </div>
            
        </>
    )
}

export default LanguagesCreateTable